import { useAppDispatch } from 'state/store';
import {
  setSelectedId,
  setConfirmationVisible,
  setModalRedirect,
} from 'state/store/reducers/customReportsSlice';

export type UseCustomReportsActions = {
  setSelectedReportId: (id: string) => void;
  setConfirmationModal: (value: boolean) => void;
  setModalRedirect: (route?: string) => void;
};

export const useCustomReportsActions = (): UseCustomReportsActions => {
  const dispatch = useAppDispatch();

  return {
    setSelectedReportId: (id: string) => {
      dispatch(setSelectedId(id));
    },

    setConfirmationModal: (value: boolean) => {
      dispatch(setConfirmationVisible(value));
    },

    setModalRedirect: (route?: string) => {
      if (route) {
        dispatch(setModalRedirect(route));
      } else {
        dispatch(setModalRedirect(undefined));
      }
    },
  };
};
